export default __webpack_public_path__ + "static/media/arrow-right-c.2a0edd92.svg";